<template>
  <!-- 时间格式 -->
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-date-picker v-model="formInline[item.key]"
    :type="dateType"
    range-separator="-"
    :placeholder="item.options.placeholder || '选择日期'"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    :default-time="defaultTime"
    :clearable="getValue(item, 'clearable', false)"
    :disabled="getValue(item, 'disabled', false)"
    :picker-options="
      (item && item.options && item.options.pickerOptions) || null
    "
    :format="defaultvalueFormat ? defaultvalueFormat : item.options.format"
    :value-format="(item && item.options && item.options.valueFormat) || null"
  ></el-date-picker>
</template>

<script>
// dateMonthPick   datePick  datetime
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    formInline: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    defaultMaxLenght: 'defaultMaxLenght',
    colon: 'colon',
    customTypeList: 'customTypeList',
    getValue: 'getValue',
    placeholder: 'placeholder',
    selectPlaceholder: 'selectPlaceholder',
    customInputHandle: 'customInputHandle',
    telBlur: 'telBlur',
    numberMax: 'numberMax',
    changeSelect: 'changeSelect',
  },
  data() {
    return {
    }
  },
  computed: {
    dateType() {
      let _type = ''
      switch (this.item.type) {
        case 'dateMonthPick':
          _type = 'daterange'
          break
        case 'datetime':
          _type = 'datetime'
          break
        default:
          _type = 'datetimerange'
          break
      }
      return _type
    },
    defaultTime() {
      let _time = []
      switch (this.item.type) {
        case 'dateMonthPick':
          _time = []
          break
        case 'datetime':
          _time = ['00:00:00', '23:59:59']
          break
        default:
          _time = ['00:00:00', '23:59:59']
          break
      }
      return _time
    },
    defaultvalueFormat() {
      let _format = ''
      switch (this.item.type) {
        case 'dateMonthPick':
          _format = ''
          break
        default:
          _format = 'yyyy-MM-dd HH:mm:ss'
          break
      }
      return _format
    },
  },
  methods: {
    // handledisabledDate(e) {
    //   console.log(e)
    // },
  },

}
</script>
